import { Box, Button, TextField } from '@eatclubapp/ec-component-library';
import { useTheme } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
import useStyles from './SearchInputStyles';
import SearchIcon from '../../assets/icon_magnifying_glass.svg';
import CloseIcon from '../../assets/icons/close.svg';
import { isEmpty } from '../../utils/baseHelpers';

const SearchInput = ({ value, setValue, placeholder = 'Search', inputStyle = {}, style = {} }) => {
  const theme = useTheme();
  const classes = useStyles();

  const [internalValue, setInternalValue] = useState(value);

  const debouncedUpdate = useCallback(debounce(setValue, 500), []);

  useEffect(() => {
    debouncedUpdate(internalValue);
  }, [internalValue, debouncedUpdate]);

  return (
    <Box className={classes.searchInput} style={style}>
      <TextField
        value={internalValue}
        onChange={setInternalValue}
        inputPrefix={<SearchIcon className={classes.searchIcon} />}
        inputSuffix={
          <Button
            type='icon'
            className={classes.searchIcon}
            disabled={isEmpty(internalValue)}
            onClick={() => {
              setValue('');
              setInternalValue('');
            }}
            style={{
              disabled: {
                backgroundColor: 'transparent',
              },
              color: isEmpty(internalValue) ? theme.colors.nimbus : theme.colors.smoke,
            }}
          >
            <CloseIcon
              style={{
                height: '10px',
                width: '10px',
                color: isEmpty(internalValue) ? theme.colors.smoke : theme.colors.black,
              }}
            />
          </Button>
        }
        style={{
          input: {
            maxWidth: '250px',
            minWidth: '120px',
            height: '32px',
            ...inputStyle,
          },
          inputHover: {},
        }}
        placeholder={placeholder}
      />
    </Box>
  );
};

export default SearchInput;
